import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import type { LoaderContext } from '@/@types/loader-context'
import { FullScreenLoader } from '@/components/ui/full-screen-loader'
import NotFoundPage from '@/not-found-page'

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'development'
    ? lazy(() =>
        // Lazy load in development
        import('@tanstack/react-router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      )
    : () => null

// No ScrollArea here: the app scrolls at window level, and wrapping the whole
// tree in an overflow-hidden ancestor silently disables every position:sticky
// element (StickyContainer headers, sticky table columns, ...).
function RootLayout() {
  return (
    <Suspense>
      <Outlet />
      <ReactQueryDevtools buttonPosition="top-right" />
      <TanStackRouterDevtools position="bottom-right" />
    </Suspense>
  )
}

export const Route = createRootRouteWithContext<LoaderContext>()({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
  pendingComponent() {
    return <FullScreenLoader className="size-32" />
  },
})
